import { InvoiceEventClassification } from './invoice-event-classification'
import { InvoiceEvent } from './invoice-event-model'

type InvoiceEventHistoryModel = {
  eventStatus: InvoiceEvent.Status
  classification: InvoiceEventClassification.Enum | undefined
  comment: string
  createdBy: string
  createdAt: Date
}

export type UnparsedInvoiceEventHistoryModel = {
  eventStatus: InvoiceEvent.Status
  classification: string
  comment: string
  createdBy: string
  createdAt: string
}

export namespace InvoiceEventHistory {
  export type Model = InvoiceEventHistoryModel

  export const parseHistory = (
    history: UnparsedInvoiceEventHistoryModel
  ): InvoiceEventHistory.Model => ({
    eventStatus: InvoiceEvent.Status[history.eventStatus],
    classification: InvoiceEventClassification.findByValue(history.classification),
    comment: history.comment,
    createdBy: history.createdBy,
    createdAt: new Date(history.createdAt)
  })
}
